import './App.css';
import {useRoutes} from "react-router-dom";
import {LoginPage} from "../features/Login/LoginPage";
import {HomePage} from "../features/Home/HomePage";
import {PrivateRoute} from "./route/PrivateRoute";
import EmpresasPage from "../features/Empresas/EmpresasPage";
import EmpresasDashboardPage from "../features/Empresas/EmpresasDashboardPage";
import ProfilePage from "../features/Profile/ProfilePage";
import SistemasPage from "../features/Sistemas/SistemasPage";
import SistemaPage from "../features/Sistemas/SistemaPage";
import MetricasPage from "../features/Metricas/MetricasPage";
import MetricaPage from "../features/Metricas/MetricaPage";
import PlanosComerciaisPage from "../features/PlanosComerciais/PlanosComerciaisPage";
import PlanoVersaoPage from "../features/PlanosComerciais/PlanoVersaoPage";
import LicencasPage from "../features/Licencas/LicencasPage";
import AssinaturaPage from "../features/Licencas/AssinaturaPage";
import UsersPage from "../features/Users/UsersPage";
import FinanceiroPage from "../features/Financeiro/FinanceiroPage";
import VigiaDeSessao from "../features/Login/VigiaDeSessao";

export default function App () {
    const routes = useRoutes([
        { path: '/login', element: <LoginPage /> },
        { path: '/', element: <PrivateRoute children={<HomePage />} /> },
        { path: '/empresas', element: <PrivateRoute children={<EmpresasPage />} /> },
        { path: '/empresas/dashboard', element: <PrivateRoute children={<EmpresasDashboardPage />} /> },
        { path: '/empresas/gestao', element: <PrivateRoute children={<EmpresasPage />} /> },
        { path: '/sistemas', element: <PrivateRoute children={<SistemasPage />} /> },
        { path: '/sistemas/:id', element: <PrivateRoute children={<SistemaPage />} /> },
        { path: '/sistemas/:id/:secao', element: <PrivateRoute children={<SistemaPage />} /> },
        { path: '/metricas', element: <PrivateRoute children={<MetricasPage />} /> },
        { path: '/metricas/:id', element: <PrivateRoute children={<MetricaPage />} /> },
        { path: '/planos-comerciais', element: <PrivateRoute children={<PlanosComerciaisPage />} /> },
        { path: '/planos-comerciais/:id', element: <PrivateRoute children={<PlanoVersaoPage />} /> },
        { path: '/planos-comerciais/:id/versoes/:numero', element: <PrivateRoute children={<PlanoVersaoPage />} /> },
        { path: '/licencas', element: <PrivateRoute children={<LicencasPage />} /> },
        { path: '/licencas/dashboard', element: <PrivateRoute children={<LicencasPage />} /> },
        { path: '/licencas/gestao', element: <PrivateRoute children={<LicencasPage />} /> },
        { path: '/licencas/permissoes', element: <PrivateRoute children={<LicencasPage />} /> },
        { path: '/licencas/:id', element: <PrivateRoute children={<AssinaturaPage />} /> },
        { path: '/licencas/:id/:aba', element: <PrivateRoute children={<AssinaturaPage />} /> },
        { path: '/financeiro', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/dashboard', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/faturas', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/cobrancas', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/inadimplencia', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/contas-receber', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/bancos', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/contas-bancarias', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/boletos', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/financeiro/formas-pagamento', element: <PrivateRoute children={<FinanceiroPage />} /> },
        { path: '/usuarios', element: <PrivateRoute children={<UsersPage />} /> },
        { path: '/profile', element: <PrivateRoute children={<ProfilePage />} /> },
    ])

    return (
        <>
            {routes}
            <VigiaDeSessao />
        </>
    );
}
